import {css} from '@emotion/css';
import {colours, fonts, spacing} from '@fo/shared/styles/variables';
import {Breakpoints, hoverAndPressInteraction, mq} from '@fo/shared/styles/mixins';

export default {
  container: css`
    label: cardLink;
    ${hoverAndPressInteraction};
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: ${spacing.XS};
    padding: ${spacing.XXS};
    color: ${colours.font.BLACK};
    text-decoration: none;
    background-color: ${colours.background.SECTION};
    border: 1px solid ${colours.border.LIGHT_GRAY};
    box-shadow: 4px 4px 4px rgba(229, 229, 229, 0.25);
    cursor: pointer;
    &:hover {
      background-color: ${colours.background.SECTION_HOVER};
    }
    &:last-child {
      margin-bottom: 0;
    }
    ${mq(Breakpoints.TABLET)} {
      flex-direction: column;
    }
  `,
  text: css`
    label: cardLink__text;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: flex-start;
    margin: 0 0 0 ${spacing.XS};
    ${mq(Breakpoints.TABLET)} {
      align-items: center;
      margin: 0;
      justify-content: start;
    }
  `,
  icon: (isCompact = false): string => css`
    label: cardLink__icon;

    ${isCompact && 'margin-bottom: 0;'};

    ${mq(Breakpoints.TABLET)} {
      margin-bottom: ${isCompact ? 0 : spacing.XXS};
    }
  `,
  label: css`
    label: cardLink__label;
    margin: 0 !important;
    font-weight: ${fonts.weight.SEMI_BOLD} !important;
    text-align: left !important;

    ${mq(Breakpoints.TABLET)} {
      font-size: ${fonts.size.L} !important;
      text-align: center !important;
    }
  `,
  description: css`
    label: cardLink__description;
    margin: ${spacing.XXS} 0 0 !important;
    font-size: ${fonts.size.L} !important;
    font-weight: ${fonts.weight.REGULAR} !important;
    text-align: left;

    ${mq(Breakpoints.TABLET)} {
      font-size: ${fonts.size.M} !important;
      text-align: center;
    }
  `,
};
